import axios from 'axios';
import mockCageData from 'views/bluviu-nutrition/features/scenarios-v2/mock/cage-data.mock';
import { mockFeedOptions } from 'views/bluviu-nutrition/features/scenarios-v2/mock/mapping-feeds.mock';
import { scenariosResultMock } from 'views/bluviu-nutrition/features/scenarios-v2/mock/scenarios-result.mock';
import { FeedOption } from 'views/bluviu-nutrition/features/scenarios-v2/types/feed-active-products.type';
import { ScenarioCageData } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-cage-data.type';
import { ScenarioListItem } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-list-item.type';
import { Summary } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-result.type';

/**
 * Returns a list of scenarios within the site with the specified globalSiteId.
 * /ewosapi/v1/scenarios/gt2-multi?globalSiteId={globalSiteId}
 */
export const getR2Scenarios = async (globalSiteId: string): Promise<ScenarioListItem[]> => {
  const res = await axios.get<ScenarioListItem[]>(`/ewosapi/v1/scenarios/gt2-multi?globalSiteId=${globalSiteId}`);
  return res.data;
};

/**
 * Returns list of scenario results
 */
export const getScenariosResult = async (): Promise<Summary[]> => {
  return scenariosResultMock;
};

export const getScenariosCageMappingData = async (scenarioId: string, globalSiteId: string): Promise<ScenarioCageData[]> => {
  return mockCageData;
};

/**
 * Get active products for a specific global site from dcdc
 * /ewosapi/v1/scenarios/gt2-multi/active-products
 */
export const getActiveProducts = async (globalSiteId: string): Promise<FeedOption[]> => {
  const res = await axios.get<FeedOption[]>(`/ewosapi/v1/scenarios/gt2-multi/active-products?globalSiteId=${globalSiteId}`);
  return res.data;
};

export const getFishGroups = async (): Promise<ScenarioCageData[]> => {
  return mockCageData;
};
